import React from 'react'
import { Button, Col, Container, Row, Table } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'

import * as Request from '../../utilities/request'
import * as I from '../../utilities/me'
import * as Messages from '../../components/ui/messages/messages'
import { User } from '../../../../back-end/common/users'
import OsLoadingImage from '../../images/xero-logo.svg'
import { AppContext } from '../../App'

const LoadingImage = OsLoadingImage

const Users = () => {
	const { appState } = React.useContext(AppContext)
	const navigate = useNavigate()

	const [messages, updateMessages] = Messages.useMessageReducer([])
	const [users, setUsers] = React.useState<User[] | null>(null)

	const getUsers = React.useCallback(async () => {
		const request = await Request.get('user')
		setUsers(request.data.users)
	}, [appState.authState])

	React.useEffect(() => {
		if (appState.authState.isLoggedIn) {
			getUsers()
		}
	}, [appState.authState, getUsers])

	const handleResendInvite = async (userID: string) => {
		if (I.have('admin', appState.permission.roleID)) {
			try {
				const result = await Request.put(`user/${userID}/invite/billy`, { resend: true })
				if (!result.data.success) {
					updateMessages(Messages.addMessage('danger', 'Unable to resend invite'))
				} else {
					updateMessages(Messages.addMessage('success', 'Invitation resent'))
					getUsers()
				}
			} catch (e) {
				console.log(e)
				updateMessages(Messages.addMessage('danger', 'Unable to resend invite'))
			}
		}
	}

	const hasLeavecal = users?.some((user) => user.lcPermission?.permissionID)
	const hasOversight = users?.some((user) => user.osPermission?.permissionID)
	const hasTayg = users?.some((user) => user.taygPermission?.permissionID)
	const hasSubsync = users?.some((user) => user.subsyncPermission?.permissionID)

	return (
		<Container className="oversight-container">
			<Row>
				<Col sm="auto">
					<h2>Users</h2>
				</Col>
				{I.have('admin', appState.permission.roleID) ? (
					<>
						<Col></Col>
						<Col sm="auto">
							<Button
								onClick={async () => {
									navigate('/user/new')
								}}
							>
								Invite User
							</Button>
						</Col>
					</>
				) : null}
			</Row>
			{users ? (
				<Row>
					<Col>
						<Table borderless responsive>
							<thead>
								<tr className="header-row">
									<th>Name</th>
									<th className={!hasLeavecal ? 'no-product-head leavecal-product' : ''}>LeaveCal</th>
									<th className={!hasOversight ? 'no-product-head oversight-product' : ''}>Oversight</th>
									<th className={!hasTayg ? 'no-product-head tayg-product' : ''}>Tax As You Go</th>
									<th className={!hasSubsync ? 'no-product-head subsync-product' : ''}>SubSync</th>
									<th></th>
								</tr>
							</thead>
							<tbody className={'card-table-body'}>
								{users
									? users.map((user, index) => (
											<tr key={user.userID} className={`stripe-row ${index % 2 === 0 ? 'stripe-row-body' : ''}`}>
												<td>
													{user.userID === appState.authState.attributes?.['custom:userId'] ||
													I.have('admin', appState.permission.roleID) ? (
														<Link to={`/user/${user.userID}`}>{`${user.firstName} ${user.lastName}`}</Link>
													) : (
														`${user.firstName} ${user.lastName}`
													)}
												</td>
												{!user.invitationAccepted ? (
													<td>
														<Button
															onClick={handleResendInvite.bind(null, user.userID!)}
															disabled={I.have('admin', appState.permission.roleID)}
														>
															Resend Invite
														</Button>
														{/* <Button onClick={handleRescindInvite} style={{ marginLeft: '5px' }}>Rescind Invite</Button> */}
													</td>
												) : (
													<td></td>
												)}
											</tr>
									  ))
									: null}
							</tbody>
							<tfoot>
								<tr>
									<td></td>
									<td className={!hasLeavecal ? 'no-product-foot leavecal-product' : ''}></td>
									<td className={!hasOversight ? 'no-product-foot oversight-product' : ''}></td>
									<td className={!hasTayg ? 'no-product-foot tayg-product' : ''}></td>
									<td className={!hasSubsync ? 'no-product-foot subsync-product' : ''}></td>
								</tr>
							</tfoot>
						</Table>
					</Col>
				</Row>
			) : (
				<div className="loading-gif">
					<img src={LoadingImage} alt="Loading ..." />
				</div>
			)}
			<Messages.Messages messages={messages} updateMessage={updateMessages} />
		</Container>
	)
}

export default Users
